import { Card, Section } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'
import type Company from 'modules/core/store/models/Company'

import { useAtsEnabled } from 'modules/ats/lib/atsEnabled'
import { CompanyPageUrlForm } from 'modules/company_page/components/CompanyPageUrlForm/CompanyPageUrlForm'
import { useCompanyPageStatusToggle } from 'modules/company_page/hooks/useCompanyPageStatusToggle'

interface Props {
  company: Company
  domains: string[]
}

export const CompanyPage = ({ company, domains }: Props) => {
  const { atsEnabled } = useAtsEnabled()
  const { running, isInstalled, isConfigured, toggleAddonStatus, needsPlanUpgrade } =
    useCompanyPageStatusToggle()

  const openCompanyPage = () => {
    const protocol = window.location.protocol
    const companyUrl = `${company.slug}.${company.domain}`
    window.open(`${protocol}//${companyUrl}`, '_blank')
  }
  const isToggleDisabled = running || (isInstalled && atsEnabled) || needsPlanUpgrade

  return (
    <>
      <Section
        illustration="URL"
        title={i18n.t('company_settings.general.company_page.title')}
        description={i18n.t(
          'company_settings.general.company_page.options.company_page.description'
        )}
        action={
          isInstalled && isConfigured
            ? {
                label: i18n.t(
                  'company_settings.general.company_page.options.company_page.open_company_page_button'
                ),
                onClick: openCompanyPage,
              }
            : undefined
        }
      >
        <Card>
          <Card.Title size="small">
            {i18n.t(
              'company_settings.general.company_page.options.company_page.publish_form_title'
            )}
          </Card.Title>
          <Card.Description>
            {i18n.t(
              'company_settings.general.company_page.options.company_page.publish_form_description'
            )}
          </Card.Description>
          <Card.ExpandableContent
            expanded={isInstalled}
            disabled={isToggleDisabled}
            onExpandChange={toggleAddonStatus}
          >
            <CompanyPageUrlForm company={company} domains={domains} />
          </Card.ExpandableContent>
        </Card>
      </Section>
    </>
  )
}
